import { noAuthApi} from "../../config/axios";
import { environments } from "../../config/environments";
import IResponseBody from "../../interfaces/response-body";
import { IUser } from "../../models/auth";

async function auth(user: IUser): Promise<string | undefined> {
  const response = await noAuthApi.post<IResponseBody<string>>(
    environments.url_login,
    user
  );

  return response.data.data;
}

async function recoverPassword(email: string):Promise<string | undefined> {
  const response = await noAuthApi.patch<IResponseBody<string>>(
    environments.url_recover_password,
    {email: email}
  );

  return response.data.data;
}

async function updatePassword(token: string, password: string):Promise<boolean> {
  const response = await noAuthApi.patch<IResponseBody<string>>(
    environments.url_update_password,
    {token, password}
  );

  return !!response.data.data;
}

export default {
  auth,
  recoverPassword,
  updatePassword
};
